"use strict";

import {onEnterViewPort} from "../libs/@elements/viewport-utils";

let popupSettings = { offset: 25, maxWidth: '340px', anchor: 'top' };

export function initInScope($scope) {
    // console.log("init mapbox");
    let $maps  = $scope.find('.js-mapbox-map');
    if ($maps && $maps.length) {

        $('head').append('<link rel="stylesheet" type="text/css" href="https://api.mapbox.com/mapbox-gl-js/v3.12.0/mapbox-gl.css">')
        $('head').append('<script src="/static/js/libs/mapbox-gl/dist/mapbox-gl.js"></script>')

        $maps.each(function (index, element) {
            let $container = $(element);
            let $containerDomEl = $container[0];
            let mainPoi = _leafletMapPois["pois"][0];
            // let $mapCanvas = $container.find('.js-mapbox-map__canvas');
            // let $mapCanvasDomEl = $mapCanvas[0];
            onEnterViewPort($(element), function () {
                // import('mapbox-gl').then(({ default: mapboxgl }) => {
                    // console.log("loaded mapbox-gl");
                    // console.log(_leafletMapPois);
                    console.log("loading mb");
                    mapboxgl.accessToken = _config.mapAccessToken;
                    let map = new mapboxgl.Map({
                        container: $containerDomEl, // container ID
                        //style: 'mapbox://styles/mapbox/streets-v12', // style URL
                        style: 'mapbox://styles/kurzzeitmiete/cmbgfkyej008101sch8cc1w14',
                        // style: 'mapbox://styles/kurzzeitmiete/cmbhrmyd900a601sc1acvhgvl',
                        center: [mainPoi.lng, mainPoi.lat], // starting position [lng, lat]
                        zoom: 15, // starting zoom
                    });
                    // console.log("new map");
                    // console.log(map);
                    setMarkers(mapboxgl, map, _leafletMapPois["pois"], mainPoi);

                    map.addInteraction('poi-click', {
                        type: 'click',
                        target: {featuresetId: 'poi', importId: 'basemap'},
                        handler(e) {
                            showPoiPopup(e, mainPoi, map, mapboxgl);
                        }
                    });

                    map.addControl(new mapboxgl.NavigationControl({
                        showZoom: true,
                        showCompass: true,
                        visualizePitch: true
                    }), 'top-left');
                    // map.on('load', function () {
                    //
                    // });
                // }).catch(function (a,b,c) {
                //     console.error(a,b,c);
                // });
            }, {
                offset: window.innerHeight * 1.5
            })
        });
    }
}

function getPoiPopupHtml(headline, text, distance = null) {
    let popupTemplate = $('.popup-content-template').first().clone();
    popupTemplate.removeClass('popup-content-template');
    let popuptextEl = popupTemplate.find('.popup-text')
    if(distance !== null) {
        // let distanceTrans = popuptextEl.data("distance-trans");
        // text = "<strong>" + distanceTrans + "</strong>:" + distance.toFixed(2) + ' km';
    }
    popuptextEl.html(text);
    popupTemplate.find('.popup-hl').text(headline);
    return popupTemplate;
}

function showPoiPopup(e, mainPoi, map, mapboxgl) {
    // console.log("POI PROPS");
    // console.log(e);
    // console.log(e.feature.properties);
    let distanceHtml = getTravelTimeHTML(e.feature.geometry.coordinates[1], e.feature.geometry.coordinates[0], mainPoi.lat, mainPoi.lng);
    let popupTemplate = getPoiPopupHtml(e.feature.properties.name, distanceHtml);
    let popup = new mapboxgl.Popup(popupSettings).setDOMContent(popupTemplate[0]).setLngLat([e.feature.geometry.coordinates[0], e.feature.geometry.coordinates[1]]).addTo(map);

    map.flyTo({ center: [e.feature.geometry.coordinates[0], e.feature.geometry.coordinates[1]] });

}
function setMarkers(mapboxgl, map, pois, mainPoi) {
    let markers = [];
    for (var i = 0, len = pois.length; i < len; i++) {
        let marker = null;
        var el = $('<div class="mapbox-marker">');
        if(pois[i].poiStyle === "special") {
            el.addClass('location-marker');
            marker = new mapboxgl.Marker({color: '#8255a0'}).setLngLat([pois[i].lng, pois[i].lat]).addTo(map);
            let distance = getTravelTimeHTML(pois[i].lat, pois[i].lng, mainPoi.lat, mainPoi.lng);
            let popupTemplate = getPoiPopupHtml(pois[i].headline, distance);
            let popup = new mapboxgl.Popup(popupSettings).setDOMContent(popupTemplate[0])
            marker.setPopup(popup);
            marker.getElement().addEventListener('click', () => {
                const lngLat = marker.getLngLat();
                map.flyTo({ center: lngLat });
            });
        } else {
            el.addClass('acco-marker');
            marker = new mapboxgl.Marker(el[0]).setLngLat([pois[i].lng, pois[i].lat]).addTo(map);
            let popupTemplate = getPoiPopupHtml(pois[i].headline, _config.mapBoxPreviewImg);
            let popup = new mapboxgl.Popup(popupSettings).setDOMContent(popupTemplate[0])
            marker.setPopup(popup);
            marker.getElement().addEventListener('click', (e) => {
                const lngLat = marker.getLngLat();
                map.flyTo({ center: lngLat });
            });
        }


    }
}
function getDistanceInKm(lat1, lon1, lat2, lon2) {
    const toRad = deg => (deg * Math.PI) / 180;
    const R = 6371; // Earth’s radius in km

    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) *
        Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}
// simple fallback helper (avoids nullish coalescing)
function pick(val, fallback) {
    return (val === undefined || val === null) ? fallback : val;
}

// format minutes (round up, minimum 1)
function formatMinutes(min) {
    var m = Math.ceil(min);
    return (m < 1 ? 1 : m) + ' min';
}

/**
 * Returns an HTML string with ETAs for Car, Bike, On foot.
 * opts: { carSpeedKmH, carDetour, carOverheadMin, bikeSpeedKmH, ... }
 */
function getTravelTimeHTML(lat1, lon1, lat2, lon2, opts) {
    if (!opts) opts = {};
    var dKm = getDistanceInKm(lat1, lon1, lat2, lon2);
    var dKmRounded = Math.round(dKm * 100) / 100;
    var modes = [
        {
            key: 'car',
            label: _config.mapTranslations['car'],
            icon: '<img class="mb-car-svg" src="/static/icons/svg/mb-car.svg">',
            speedKmH: pick(opts.carSpeedKmH, 33),
            detour: pick(opts.carDetour, 1.35),
            overheadMin: pick(opts.carOverheadMin, 2)
        },
        // {
        //     key: 'bike',
        //     label: _config.mapTranslations['bike'],
        //     icon: '<i class="icon icon-bike"></i>',
        //     speedKmH: pick(opts.bikeSpeedKmH, 15),
        //     detour: pick(opts.bikeDetour, 1.25),
        //     overheadMin: pick(opts.bikeOverheadMin, 1)
        // },
        {
            key: 'foot',
            label: _config.mapTranslations['onfoot'],
            icon: '<i class="icon icon-mb-walk"></i>',
            speedKmH: pick(opts.footSpeedKmH, 5),
            detour: pick(opts.footDetour, 1.15),
            overheadMin: pick(opts.footOverheadMin, 0)
        }
    ];

    var html = '<div class="eta-list">';
    html += ''
        + '<div class="eta eta-">'
        +   '<span class="eta-icon" aria-hidden="true"><i class="icon icon-mb-dist"></i></span> '
        +   '<span class="eta-label"></span> '
        +   '<strong class="eta-time">' + dKmRounded + ' km</strong>'
        + '</div>';
    for (var i = 0; i < modes.length; i++) {
        var m = modes[i];
        var adjustedKm = dKm * m.detour;
        var travelMin = (adjustedKm / m.speedKmH) * 60 + m.overheadMin;

        html += ''
            + '<div class="eta eta-' + m.key + '">'
            +   '<span class="eta-icon" aria-hidden="true">' + m.icon + '</span> '
            +   '<span class="eta-label"></span> '
            +   '<strong class="eta-time">' + formatMinutes(travelMin) + '</strong>'
            + '</div>';
    }
    html += '</div>';

    html += '<hr><div class="eta-hint-text">' + _config.mapTranslations['etaHintText'] + '</div>';
    return html;
}